import { useEffect, useRef } from "react";
import { Input } from "../Input/Input";

export const useAutoFocus = (isActive?: boolean) => {
  // this hook is used to focus our custom input element specifically
  const focusRef = useRef<Input>(null);

  useEffect(() => {
    if (isActive && focusRef.current) {
      focusRef.current.focus();
    }
  }, [isActive, focusRef]);
  return focusRef;
}
